import redirects from '../../redirects.json';
import handleTrailingSlash from '../../shared/base/utils/handleTrailingSlash';

export default function getIfSimpleRedirect(url) {
  if (!url) return;
  const pathname = url.includes('?') ? url.split('?')[0] : url;

  return redirects.find(redirect => {
    if (
      handleTrailingSlash(redirect.fromPath) === handleTrailingSlash(redirect.fromPath.includes('?') ? url : pathname)
    )
      return redirect;
  });
}
